"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNIT_OF_MEASUREMENT = void 0;
/* eslint-disable import/prefer-default-export */
exports.UNIT_OF_MEASUREMENT = 'UNIT_OF_MEASUREMENT';
